import React, { useEffect, useState } from "react";
import { BsXLg } from "react-icons/bs";
import { Button, Card, CardBody, CardFooter, CardTitle } from "reactstrap";
import api from "../../api/api";
import LoadingIcon from "../LoadingIcon/LoadingIcon";
import { useParams } from "react-router-dom";
import GalleryNewDetectedObject from "../GalleryNewDetectedObject/GalleryNewDetectedObject";
import useNewDetectedObjectStore from "../../store/useNewDetectedObjectStore";

const ModalNewDetectedObject = ({
  toggle,
  setActivePointSupervision,
  toggleSupervisionMode,
  onNewPoint,
}) => {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [galleryModal, setGalleryModal] = useState(false);
  const [updateMapPoints, setUpdateMapPoints] = useState(false);
  const [newCreatedMapPoints, setNewCreatedMapPoints] = useState(null);

  const {
    newPointPosition,
    setPreviewImagesVisible,
    setPreviewImagesNewPoint,
    type,
    setType,
  } = useNewDetectedObjectStore();

  const toggleGalleryModal = () => setGalleryModal(!galleryModal);

  let { id: projectId } = useParams();

  useEffect(() => {
    const getImagesByCoordinates = async () => {
      setLoading(true);

      try {
        const { data } = await api.post("/images/coordinates", {
          latitude: newPointPosition.lat,
          longitude: newPointPosition.lng,
          projectId: projectId,
        });

        setImages(data);
        setPreviewImagesNewPoint(data);
        setPreviewImagesVisible(true);
        setLoading(false);
      } catch (e) {
        console.log(e);
      }
    };

    getImagesByCoordinates();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [newPointPosition]);

  useEffect(() => {
    if (updateMapPoints && newCreatedMapPoints !== null) {
      onNewPoint(newCreatedMapPoints, type);
    }
  }, [updateMapPoints, newCreatedMapPoints, type, onNewPoint]);

  return (
    <>
      {galleryModal && images.length > 0 && (
        <GalleryNewDetectedObject
          imageArray={images}
          isOpen={galleryModal}
          toggle={toggleGalleryModal}
          coordinates={newPointPosition}
          setActivePointSupervision={setActivePointSupervision}
          toggleSupervisionMode={toggleSupervisionMode}
          toggleModalNewDetectedObject={toggle}
          setUpdateMapPoints={setUpdateMapPoints}
          setNewCreatedMapPoints={setNewCreatedMapPoints}
        />
      )}

      <Card
        style={{
          right: "10%",
          top: "10%",
          position: "absolute",
          zIndex: "1030",
          display: "block",
          overflowX: "scroll",
          width: "350px",
        }}
      >
        <CardTitle>
          <div className="d-flex align-items-center p-3 gap-1">
            <BsXLg style={{ cursor: "pointer" }} onClick={toggle} />
          </div>
          <hr className="m-0" />
        </CardTitle>
        <CardBody>
          <select
            className="form-select"
            name="newObjectType"
            defaultValue={type}
            onChange={(e) => {
              setType(e.target.value);
            }}
          >
            <option value="poles">Poste</option>
            <option value="trees">Árvore</option>
          </select>

          <div>
            <span>Latitude: {newPointPosition.lat}</span>
            <br />
            <span>Longitude: {newPointPosition.lng}</span>
          </div>
          <br />
          <div>
            <span>{images.length} imagens encontradas</span>

            {loading && <LoadingIcon />}
          </div>
        </CardBody>
        <CardFooter style={{ display: "flex", justifyContent: "center" }}>
          <Button
            disabled={images.length === 0}
            onClick={() => toggleGalleryModal()}
          >
            Selecionar Imagens
          </Button>
        </CardFooter>
      </Card>
    </>
  );
};

export default ModalNewDetectedObject;
